function timestampOrNow(value) {
    return typeof value === 'string' && value ? value : new Date().toISOString();
}
/** Discovery responses may omit organization timestamps present on full SDK records. */
export function discoveryOrganizationTimestamps(organization) {
    return {
        created_at: timestampOrNow('created_at' in organization ? organization.created_at : undefined),
        updated_at: timestampOrNow('updated_at' in organization ? organization.updated_at : undefined),
    };
}
